import React from 'react';
import PropTypes from 'prop-types';

export default function HowItWorksModal({ show, onClose }) {
  if (!show) return null;

  const steps = [
    {
      title: "1. Join a Group",
      description: "Find and join tennis groups that match your style. Public groups are open to all, while private groups require approval from admins.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      title: "2. Propose Play Time",
      description: "Create a proposal for a match or practice session. Choose the type of play, time, and location that works for you.",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      title: "3. Get Players",
      description: "Other players can accept your proposal, or you can accept open proposals from others. Once enough players join, it's game time!",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      )
    },
    {
      title: "4. Meet & Play!",
      description: "Meet at the courts at the scheduled time and enjoy your tennis session!",
      icon: (
        <svg className="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full shadow-lg">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-textDark">How It Works</h2>
          <button
            onClick={onClose}
            className="text-textMed hover:text-textDark"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                {step.icon}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-textDark mb-1">{step.title}</h3>
                <p className="text-textMed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Get Started Button */}
        <div className="mt-8 text-center">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-primary text-white font-semibold rounded-lg hover:bg-primaryDark transition"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}

HowItWorksModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}; 